import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import CheckInputBase from "../CheckInputBase/CheckInputBase";
import Icon from "../../imagery/Icon";
import Typography from "../../typography/Typography";
import { CheckBoxProps } from "./CheckBox.types";
import { StyledCheckBoxInput, StyledCheckBoxCircle } from "./CheckBox.styles";
import { useId } from "@react-aria/utils";

const CheckBox: FC<CheckBoxProps> = ({
	id,
	className,
	label,
	colorOn,
	checked,
	...props
}) => {
	const block = new BemIt("CheckBox");
	const uid = useId(id);
	return (
		<CheckInputBase className={addClass(className).after(block)} htmlFor={uid}>
			<StyledCheckBoxInput
				id={uid}
				type="checkbox"
				defaultChecked={checked}
				aria-label={label}
				{...props}
			/>
			<StyledCheckBoxCircle className={block.el("circle").out}>
				<Icon name="check" size="sm" color="light_1" />
			</StyledCheckBoxCircle>
			<Typography
				className={block.el("label").out}
				variant="body"
				colorOn={colorOn}
			>
				{label}
			</Typography>
		</CheckInputBase>
	);
};

export default CheckBox;
